export default "__VITE_ASSET__dgreeuc0__"